import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostMcpOAuthApproveRequest = {
	clientId: string;
	codeChallenge: string;
	codeChallengeMethod: string;
	redirectUri: string;
	state: string;
};

export type PostMcpOAuthApproveResponse = {
	redirectTo: string;
};

export const postMcpOAuthApprove = createPostEndpoint<PostMcpOAuthApproveRequest, PostMcpOAuthApproveResponse>(
	'/api/mcp/oauth/authorize/approve'
);
